const fansChannelsPageStyles = () => ({
  container: {
    padding: '2% 3%',
  },
  header: {
    marginBottom: 16,
  },
  tableContainer: {
    marginTop: 8,
  },
  competitionInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  competitionLogo: {
    width: 32,
    height: 32,
    marginRight: 12,
  },
  emptyState: {
    padding: 48,
    textAlign: 'center',
  },
})

export default fansChannelsPageStyles
